import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { usePermissionContext } from '../../contexts/PermissionContext'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface AdminRouteProps {
  children: React.ReactNode
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isLoading: authLoading } = useAuth()
  const { isPlatformAdmin, isLoading: permLoading } = usePermissionContext()

  if (authLoading || permLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user || !isPlatformAdmin) {
    return <Navigate to="/app" replace />
  }

  return <>{children}</>
}
